<template>
  <div class="wai">
    <div class="curd">
      <div class="sou">
        <el-input v-model="page.orderNo" style="width: 240px;margin-right: 20px;" placeholder="订单号" clearable />
        <el-input v-model="page.name" style="width: 240px;margin-right: 20px;" placeholder="姓名" clearable />
        <el-input v-model="page.cardid" style="width: 240px;margin-right: 20px;" placeholder="身份证号" clearable />
        <el-button round @click="getlist()">查询</el-button>
      </div>
    </div>
    <div class="zhuyao">
      <div class="juese">
        <div class="zhu">
          <div class="biao">
            <el-table
              :row-style="({ row }) => row.orderNo === order?.orderNo ? {'background-color': '#f1fe76'} : {}"
              :data="list"
              style="width: 100%"
            >
              <el-table-column label="订单号">
                <template #default="{row}">
                  <span>{{ row.orderNo }}</span>
                  <el-tag v-if="row.signfile" size="small" type="success" style="margin-left:8px">已CA签发</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template #default="{ row }">
                  <el-button type="primary" @click="xuanze(row)" size="small">审核</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              @current-change="getlist"
              :pager-count="4"
              v-model:page-size="page.pageSize"
              v-model:current-page="page.pageno"
              background
              layout="prev, pager, next"
              :total="page.total"
            />
          </div>
        </div>
      </div>
      <div class="ziyuan">
        <div class="tu">
          <VueOfficePdf
            v-if="order"
            :key="pdfKey"
            :src="'https://lanxiaoxiao.obs.cn-north-4.myhuaweicloud.com/' + (order.signfile || order.authfile)"
            @error="handleError"
          />
        </div>
        <div class="wenzi">
          <div v-if="order">
            <div class="zu">
              <div class="lab">姓名</div>
              <div class="val">{{order.name}}</div>
            </div>
            <div class="zu">
              <div class="lab">身份证</div>
              <div class="val">{{formatIdCard(order.cardid)}}</div>
            </div>
            <div class="zu">
              <div class="lab">提交时间</div>
              <div class="val">{{order.create_time}}</div>
            </div>
            <div class="zu" style="margin-top:12px">
              <div class="lab">CA签章状态</div>
              <div class="val" :class="[order.signfile ? 'text-success' : 'text-warning']">
                {{ order.signfile ? "已CA签发" : caSignLoading ? "签发中" : "未签发" }}
              </div>
            </div>
          </div>

          <!-- 🔽 新增：PDF数字签名本地验签报告区域 -->
          <div v-if="order && order.signfile" class="verify-wrap" style="margin-top:16px;border-top:1px solid #eee;padding-top:10px;text-align:left;">
            <div style="font-weight:bold;font-size:14px;margin-bottom:8px">📜本地PDF签名验签预览</div>
            <el-button size="small" :loading="verifyLoading" @click="doPdfVerify">执行验签解析</el-button>
            <el-alert v-if="verifyTip" :title="verifyTip" type="info" :closable="false" style="margin:8px 0;font-size:12px" />

            <div v-if="verifyResult" class="verify-result">
              <div v-for="item in verifyResult.report" :key="item.key" style="font-size:12px;display:flex;gap:6px;margin:4px 0;">
                <span :style="{color:item.pass?'#67c23a':'#f56c6c'}">{{item.pass?'有效':'无效'}}{{item.key}}</span>
              </div>
              <div style="margin-top:8px;">
                <div style="font‑weight:bold;font‑size:13px">证书链(本地解析预览)</div>
                <div v-for="cert in verifyResult.chain" :key="cert.serial" style="border:1px solid #eee;padding:6px;margin:4px 0;border‑radius:4px;font‑size:11px;">
                  <div><b>{{cert.role}}</b></div>
                  <div>主体：{{cert.subject}}</div>
                  <div>颁发者：{{cert.issuer}}</div>
                  <div>序列号：{{cert.serial}}</div>
                  <div>有效期：{{cert.validFrom}} ~ {{cert.validTo}}</div>
                </div>
              </div>
              <div style="color:#999;font‑size:11px;margin‑top:6px">⚠️仅前端预览，业务以服务端校验结果为准</div>
            </div>
          </div>

          <div class="shenpi" v-if="order">
            <div class="you" style="margin-bottom: 12px;">
              <el-button style="width: 100%;height: 40px;" round type="danger" @click="shenhetype = 1">驳回</el-button>
            </div>
            <div class="ca-btn-wrap" style="margin-bottom:12px">
              <el-button
                style="width: 100%;height: 40px;"
                round
                type="info"
                :loading="caSignLoading"
                :disabled="!!order.signfile"
                @click="handleCaSign"
              >
                CA签发
              </el-button>
            </div>
            <div class="wuzui">
              <el-button style="width: 100%;height: 40px;" round type="success" @click="shenhetype = 2">审核通过</el-button>
            </div>

            <div class="youerci" style="margin-top: 50px;" v-if="shenhetype === 1">
              <div style="margin-bottom: 20px;">
                <el-input v-model="zuizhuang" placeholder="驳回原因" clearable />
              </div>
              <div>
                <el-button style="width: 100%;height: 40px;" round type="danger" @click="youzui()">二次确认驳回</el-button>
              </div>
            </div>
            <div class="youerci" style="margin-top: 50px;" v-if="shenhetype === 2">
              <div>
                <el-button
                  style="width: 100%;height: 40px;"
                  round
                  type="success"
                  :disabled="!order.signfile"
                  @click="wuzui()"
                >
                  二次确认审核通过
                </el-button>
                <div v-if="!order.signfile" style="color:#f56c6c;font-size:12px;margin-top:6px;text-align:center">请先完成CA签发后再审核通过</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus';
import VueOfficePdf from '@vue-office/pdf'
import { onMounted, reactive, ref } from 'vue';
import { getcaWaitList, addszhca, caapprovalStart } from '@/api/api'
import { useLoadingStore } from '../../store/loadingstore'
// 导入PDF验签模块
import { verifyPdfSignature } from '@/js/pdf-signature-verify'

const loadingStore = useLoadingStore();

onMounted(() => {
  getlist()
})
const order = ref(null)
const zuizhuang = ref('')
const shenhetype = ref(0)

const caSignLoading = ref(false)
const pdfKey = ref(0)

// 验签相关变量
const verifyLoading = ref(false)
const verifyTip = ref('')
const verifyResult = ref(null)

const page = reactive({
  pageno: 1,
  pageSize: 13,
  total: 0,
  orderNo: '',
  name: '',
  cardid: ''
})

const list = ref([])

const getlist = async () => {
  shenhetype.value = 0
  zuizhuang.value = ''
  verifyResult.value = null
  verifyTip.value = ''
  const data = {
    page: page.pageno,
    pageSize: page.pageSize,
    orderNo: page.orderNo,
    name: page.name,
    cardid: page.cardid
  }
  const res = await getcaWaitList(data)
  if (res.code === 200) {
    list.value = res.data.list || []
    page.pageno = res.data.page
    page.pageSize = res.data.pageSize
    page.total = res.data.total
    if (res.data.list?.length) {
      order.value = { ...res.data.list[0] }
    } else {
      order.value = null
    }
  } else {
    ElMessage.error(res.message)
  }
}

const xuanze = (row) => {
  order.value = { ...row }
  shenhetype.value = 0
  zuizhuang.value = ''
  verifyResult.value = null
  verifyTip.value = ''
}

const formatIdCard = (cardId) => {
  if (!cardId || cardId.length !== 18) {
    return cardId ?? '';
  }
  const parts = [
    cardId.substring(0, 3),
    cardId.substring(3, 6),
    cardId.substring(6, 10),
    cardId.substring(10, 14),
    cardId.substring(14)
  ];
  return parts.join(' ');
};

// CA签发 使用 addszhca
const handleCaSign = async () => {
  if (!order.value?.orderNo) {
    ElMessage.warning('请先选择一条订单');
    return;
  }
  caSignLoading.value = true
  try {
    const res = await addszhca({ orderNo: order.value.orderNo })
    if (res.code === 200 && res.subcode === 200001) {
      order.value.signfile = res.data.obsurl
      pdfKey.value++
      ElMessage.success(res.message || "CA签发完成，请审阅签章PDF后审核")
      //签发完毕清空上次验签结果，需要手动点击【执行验签解析】重新解析
      verifyResult.value = null
      verifyTip.value = ''
    } else {
      ElMessage.error(res.message || "CA签发失败")
    }
  } catch (err) {
    ElMessage.error("CA签发请求异常，请检查网络或后端服务")
  } finally {
    caSignLoading.value = false
  }
}

// 下载PDF二进制 + 调用验签模块
const doPdfVerify = async () => {
  if (!order.value?.signfile) {
    verifyTip.value = '没有签章PDF，不可验签'
    return
  }
  verifyLoading.value = true
  verifyTip.value = '正在下载PDF并解析签名...'
  verifyResult.value = null
  try {
    const pdfUrl = 'https://lanxiaoxiao.obs.cn-north-4.myhuaweicloud.com/' + order.value.signfile
    const resp = await fetch(pdfUrl)
    if (!resp.ok) {
      verifyTip.value = `PDF下载失败，HTTP:${resp.status}，检查OBS CORS跨域配置`
      return
    }
    const buf = await resp.arrayBuffer()
    const u8 = new Uint8Array(buf)
    // 调用pdf‑signature‑verify.js导出方法
    const ret = await verifyPdfSignature(u8, { forcePureJs: false })
    verifyResult.value = ret
    if(ret.certCount ===0){
      verifyTip.value = '解析完成，未提取到证书'
    }else{
      verifyTip.value = `解析完成，获取${ret.certCount}张证书`
    }
  } catch (err) {
    console.error(err)
    verifyTip.value = '验签解析异常：' + err.message
  } finally {
    verifyLoading.value = false
  }
}

const youzui = () => {
  if (!zuizhuang.value?.trim()) {
    ElMessage.error("审核驳回原因不能为空！")
    return
  }
  const data = {
    orderNo: order.value.orderNo,
    state: 0,
    state_tips: zuizhuang.value.trim()
  }
  submitCaApproval(data)
}

const wuzui = () => {
  if (!order.value?.signfile) {
    ElMessage.warning("请先执行CA签发，审阅签章PDF后再审核通过")
    return
  }
  const data = {
    orderNo: order.value.orderNo,
    state: 2,
    state_tips: ''
  }
  submitCaApproval(data)
}

const submitCaApproval = async (data) => {
  loadingStore.show('正在提交审批...');
  try {
    const res = await caapprovalStart(data)
    if (res.code === 200) {
      ElMessage.success("审批完成")
      getlist()
    } else {
      ElMessage.error(res.message)
    }
  } catch (e) {
    ElMessage.error('审批提交异常')
  } finally {
    loadingStore.hide();
  }
}

const handleError = () => {
  ElMessage.error("PDF文件加载失败，请检查文件地址")
}
</script>


<style lang="scss" scoped>
.wai {
  width: 100%;
  height: 100%;
  padding: 0 20px;

  .curd {
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .zhuyao {
    display: flex;
    justify-content: center;
    height: calc(100% - 40px);

    .juese {
      width: 25%;
      height: 100%;

      .zhu {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        border-radius: 10px;

        .biao {
          width: 100%;
          height: calc(100% - 45px);
        }

        .page {
          padding-top: 10px;
          height: 35px;
          display: flex;
          justify-content: right;
        }
      }
    }

    .ziyuan {
      width: 75%;
      height: 100%;
      padding-left: 20px;
      display: flex;
      justify-content: space-between;

      .tu {
        height: 100%;
        overflow-y: auto;
        width: calc(100% - 250px);
      }

      .wenzi {
        width: 250px;

        .zu {
          text-align: center;
          margin-bottom:8px;
          .lab {
            font-size: 16px;
            color: #8c8c8c;
          }
          .val {
            font-size: 18px;
            color: #000;
            font-weight: bold;
          }
        }

        .shenpi {
          margin-top: 30px;
        }
      }
    }
  }
}

.text-success{
  color:#67c23a
}
.text-warning{
  color:#e6a23c
}
</style>
